import { Space } from 'antd'
import { BaseButton } from 'components/elements/BaseButton'
import { BtnAnch } from 'components/elements/global'
import { SVGBlockCall, SVGBlockMail } from 'components/icons'
import React, { FC, ReactNode } from 'react'

const SimpleBlockItem: FC<{
 actions?: ReactNode[]
 onClose?: () => void
 text?: any
 onDelete?: () => void
 onEdit?: () => void
 contentClassName?: string
 call?: boolean
 showSMS?: boolean
 onSendSMS?: () => void
 showEmail?: boolean
 onSendEmail?: () => void
 onView?: () => void
 onBlock?: () => void
 onUnblock?: () => void
 blockType?: 'sms' | 'email'
 tooltip?: {
  view?: string
  block?: string
  unblock?: string
  sendMail?: string
  sendSms?: string
  delete?: string
  edit?: string
  call?: string
  close?: string
 }
 contentNode?: ReactNode
}> = ({
 text,
 onDelete,
 onEdit,
 onClose,
 actions,
 contentClassName = '',
 call,
 showSMS,
 onSendSMS,
 onSendEmail,
 showEmail,
 onView,
 onBlock,
 onUnblock,
 blockType,
 tooltip,
 contentNode,
}) => {
 const primaryAction = call ? undefined : onSendEmail ?? onSendSMS ?? undefined

 const contentEl = contentNode ?? (
  <span className={`content ${contentClassName}`}>{text}</span>
 )

 return (
  <div className="item-block-li">
   {call ? (
    <a href={`tel:${text}`} className="content item-block-content-link">
     {contentEl}
    </a>
   ) : primaryAction ? (
    <span
     className="item-block-content-link"
     onClick={primaryAction}
     role="button"
     tabIndex={0}
     onKeyDown={(e) => e.key === 'Enter' && primaryAction()}
    >
     {contentEl}
    </span>
   ) : (
    contentEl
   )}
   <span className="action">
    {actions}

    {call && (
     <BaseButton
      href={`tel:${text}`}
      buttonStyle="outline"
      size="small"
      buttonType="primary"
     >
      <i className="fas fa-phone" />
     </BaseButton>
    )}
    {showSMS && (
     <BaseButton
      buttonStyle="outline"
      onClick={onSendSMS}
      size="small"
      buttonType="primary"
      icon={<i className="fas fa-comment-alt" />}
      tooltipText={tooltip?.sendSms ?? ''}
     />
    )}
    {showEmail && (
     <BaseButton
      buttonStyle="outline"
      onClick={onSendEmail}
      size="small"
      buttonType="primary"
      icon={<i className="fas fa-envelope" />}
      tooltipText={tooltip?.sendMail ?? ''}
     />
    )}
    {onView && (
     <BaseButton
      tooltipText={tooltip?.view}
      buttonStyle="outline"
      buttonType="danger"
      onClick={onView}
      size="small"
      danger
      icon={<i className="fas fa-eye" />}
     />
    )}
    {onEdit && (
     <BaseButton
      buttonStyle="outline"
      onClick={onEdit}
      size="small"
      buttonType="primary"
      icon={<i className="fas fa-edit" />}
      tooltipText={tooltip?.edit ?? ''}
     />
    )}
    {onUnblock && (
     <BaseButton
      buttonStyle="outline"
      onClick={onUnblock}
      size="large"
      buttonType="primary"
      icon={blockType === 'email' ? <SVGBlockMail /> : <SVGBlockCall />}
      tooltipText={tooltip?.unblock ?? ''}
     />
    )}
    {onBlock && (
     <BaseButton
      buttonStyle="outline"
      onClick={onBlock}
      size="large"
      buttonType="primary"
      icon={blockType === 'email' ? <SVGBlockMail /> : <SVGBlockCall />}
      tooltipText={tooltip?.block ?? ''}
     />
    )}
    {onDelete && (
     <BaseButton
      buttonStyle="outline"
      buttonType="danger"
      onClick={onDelete}
      size="small"
      danger
      icon={<i className="fas fa-trash" />}
      tooltipText={tooltip?.delete ?? ''}
     />
    )}
    {onClose && (
     <BaseButton
      tooltipText={tooltip?.close}
      buttonStyle="outline"
      buttonType="danger"
      onClick={onClose}
      size="small"
      danger
      icon={<i className="fas fa-times" />}
     />
    )}
   </span>
  </div>
 )
}
export default SimpleBlockItem
